$.formUtils.addValidator({
	name : 'distance',
	validatorFunction : function(value, $el, config, language, $form) {
		var isValid;
		var data = $form.data('inputData');
		var mode = $el.data('validationDistanceMode') || 'date';
		var field = $el.data('validationDistanceField') || 'days';
		var type = $el.data('validationDistanceType') || 'lt';
		var key = $el.data('validationDistanceKey');
		var distance = $el.data('validationDistanceValue');
		var thisValue = $el.val();
		var otherValue = data[key];
		if(thisValue == null || thisValue == '' || otherValue == null || otherValue == ''){
			// skip comparison if one of the fields is missing
			isValid = true
		} else {
			switch (mode) {
			case 'date':
				isValid = this.compareValues(this.differenceBetweenDates(thisValue, otherValue, field), distance, type);
				break;
			default:
				console.log('validation mode not yet implemented:', mode);
				isValid = true;
			break;
			}
		}
		return isValid;
	},
	differenceBetweenDates: function(d1, d2, field){
		var pattern = 'DD/MM/YYYY';
		var distance = moment(d1, pattern).diff(moment(d2, pattern), field);
		return Math.abs(distance);
	},
	compareValues: function(delta, distance, type){
		switch (type) {
		case 'lt':
			return delta < distance;
		case 'le':
			return delta <= distance;
		case 'gt':
			return delta > distance;
		case 'ge':
			return delta >= distance;
		case 'eq':
			return delta == distance;
		case 'nq':
			return delta != distance;
		default:
			return true;
		}
	},
	errorMessage : 'This error message must be configured via \"data-validation-error-msg-distance\" attribute',
	errorMessageKey: ''
});
